import React from "react";
import { useI18n } from "@/lib/i18n";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = {
  es: [
    ["¿Cómo compro un producto?", "Explora el marketplace, abre el producto que te guste y pulsa 'Comprar ahora'. El pago se procesa de forma segura con Stripe y podrás descargar el archivo al instante."],
    ["¿Cómo empiezo a vender?", "Crea una cuenta como vendedor (o conviértete en uno desde tu dashboard), sube tu producto y usa la IA para generar el título, la descripción y los tags. Publica en minutos."],
    ["¿Qué es la búsqueda inteligente?", "Nuestra búsqueda entiende la intención detrás de tus palabras, no solo coincidencias exactas. Describe lo que necesitas en lenguaje natural y la IA encontrará lo más relevante."],
    ["¿Cómo descargo mis compras?", "Ve a 'Mis compras'. Ahí encontrarás todos tus productos con un botón de descarga siempre disponible."],
    ["¿Qué métodos de pago aceptan?", "Aceptamos tarjetas de crédito y débito a través de Stripe. En modo de prueba puedes usar la tarjeta 4242 4242 4242 4242."],
  ],
  en: [
    ["How do I buy a product?", "Browse the marketplace, open a product you like and hit 'Buy now'. Payment is processed securely via Stripe and you can download the file instantly."],
    ["How do I start selling?", "Create a seller account (or upgrade from your dashboard), upload your product and use AI to generate the title, description and tags. Publish in minutes."],
    ["What is smart search?", "Our search understands the intent behind your words, not just exact matches. Describe what you need in natural language and the AI finds the most relevant results."],
    ["How do I download my purchases?", "Go to 'My purchases'. There you'll find all your products with a download button always available."],
    ["What payment methods do you accept?", "We accept credit and debit cards through Stripe. In test mode you can use card 4242 4242 4242 4242."],
  ],
};

export default function Help() {
  const { t, lang } = useI18n();
  return (
    <div className="max-w-2xl mx-auto px-5 py-16">
      <h1 className="font-display text-3xl md:text-4xl font-extrabold text-[#0F172A] mb-8">{t("help.title")}</h1>
      <Accordion type="single" collapsible className="space-y-3">
        {faqs[lang].map(([q, a], i) => (
          <AccordionItem key={i} value={`item-${i}`} className="bg-white border border-[#E2E8F0] rounded-2xl px-5" data-testid={`faq-${i}`}>
            <AccordionTrigger className="font-display font-bold text-[#0F172A] hover:no-underline text-left">{q}</AccordionTrigger>
            <AccordionContent className="text-[#475569] leading-relaxed">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
